import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: null,
  isLoaded: false,
};

const treatmentDemandSlice = createSlice({
  name: "treatmentDemand",
  initialState,
  reducers: {
    setTreatmentDemands: (state, { payload }) =>
    {
      state.list = payload;
      state.isLoaded = true;
    },
    filterTreatmentDemands: (state, {payload}) => {
      //*buradaki payload olarak sadece treatmentdemandın kendi idsini gönderiyorum
      state.list = state.list.filter(d => d.id !== payload);
    },
    addMessageToSelectedDemandMessageList: (state, { payload }) =>
    {
      state.selected.messages.push(payload);
    },
    setCurrentTreatmentDemand: (state, { payload }) =>
    {
      state.selected = payload;
    },
    removeTreatmentDemandFromList: (state, { payload }) =>
    {
      state.list = state.list.filter((item) => item.id !== payload);
    },
    updateTreatmentDemands: (state, { payload }) =>
    {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
  },
});

export const {
  setTreatmentDemands,
  setCurrentTreatmentDemand,
  addMessageToSelectedDemandMessageList,
  removeTreatmentDemandFromList,
  updateTreatmentDemands,
  filterTreatmentDemands,
} = treatmentDemandSlice.actions;
export default treatmentDemandSlice.reducer;
